export default "__VITE_PUBLIC_ASSET__33fef20c__"